"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateLike = exports.DateLike = exports.isISODate = void 0;
const validation_1 = require("../validator/validation");
const iso8601 = /^[0-9]{4}(?:-[0-9]{2}){2}T[0-9]{2}(?::[0-9]{2}){2}(?:\.[0-9]*)?Z$/;
function matchesISODate(value) {
    try {
        return iso8601.test(value) && Number.isFinite(Date.parse(value));
    }
    catch (e) {
        return false;
    }
}
exports.isISODate = validation_1.isString.which((0, validation_1.satisfiesPredicate)(matchesISODate));
exports.DateLike = {
    toISOString(dateLike) {
        if (dateLike instanceof Date) {
            return dateLike.toISOString();
        }
        else {
            return dateLike;
        }
    },
    toDate(dateLike) {
        if (dateLike instanceof Date) {
            return dateLike;
        }
        else {
            return new Date(dateLike);
        }
    },
};
exports.isDateLike = (0, validation_1.isSomeOf)(exports.isISODate, (0, validation_1.isInstanceOf)(Date));
//# sourceMappingURL=datelike.js.map